import Manager from '../model/entity/dicom/Manager';
import * as types from '../constants/ActionTypes';

const initialState: Manager = new Manager();

export default (manager: Manager = initialState, action: Object) => {
  switch (action.type) {
    // case types.SET_STUDIES_LIST: {
    //   const { payload = {} } = action;
    //   return {
    //     ...manager,
    //     studiesList: payload,
    //   };
    // }
    // case types.SET_FILTERS: {
    //   const { payload = {} } = action;
    //   return {
    //     ...manager,
    //     filters: payload,
    //   };
    // }
    
    case types.SET_STUDY_SEARCH_CONFIG: {
      const { payload = {} } = action;
      return {
        ...manager,
        studySearchConfig: payload,
      };
    }
    
    case types.SET_SEARCH: {
      const { payload = {} } = action;

      return {
        ...manager,
        studiesList: payload.studiesList,
        filters: payload.filters,
        isNextPageAvailable: payload.isNextPageAvailable ?? manager.isNextPageAvailable,
        totalStudies: payload.totalStudies || manager.totalStudies,
        isRaim: payload.isRaim || manager.isRaim,
      };
    }
    case types.SET_SELECTED_PACS_INDEX: {
      return {
        ...manager,
        selectedPacsIndex: action.payload,
        currentPage: 0,
        studiesList: [],
        isNextPageAvailable: false,
        totalStudies: 0,
        isRaim: null,
      };
    }
    case types.SET_CURRENT_PAGE: {
      const { payload = {} } = action;
      return {
        ...manager,
        currentPage: payload,
      };
    }
    case types.SET_ROWS_PER_PAGE: {
      const { payload = {} } = action;
      return {
        ...manager,
        rowsPerPage: payload,
      };
    }
    case types.SET_NEXT_PAGE_DISABLED: {
      const { payload = {} } = action;
      return {
        ...manager,
        isNextPageAvailable: !payload,
      };
    }
    // case types.SET_TOTAL_STUDIES: {
    //   const { payload = {} } = action;
    //   return {
    //     ...manager,
    //     totalStudies: payload,
    //   };
    // }

    default:
      return manager;
  }
};
